<template>
  <v-tooltip :close-delay="closeDelay" content-class="pop-hover" v-model="show" :bottom="bottom" :top="top">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" @click="show = showOnClick && !show">
        <slot />
      </span>
    </template>
    <div class="pop-hover-wrapper">
      <header class="pop-hover-header" :class="headerClass">
        <slot name="pop-hover-header"></slot>
      </header>
      <div class="pop-hover-content">
        <slot name="pop-hover-content"></slot>
      </div>
      <footer class="pop-hover-footer">
        <slot name="pop-hover-footer"></slot>
      </footer>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "PopHover",
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: prop => ['primary', 'warning'].includes(prop),
    },
    top: {
      type: Boolean
    },
    bottom: {
      type: Boolean
    },
    showOnClick: {
      type: Boolean,
      default: false
    },
    closeDelay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    headerClass() {
      return `bg-${this.type}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_i18n-mixins.scss";
.pop-hover {
    background-color: white;
    padding: 0;
    width: 250px;
    box-shadow: 0 2px 5px 1px rgba(18, 52, 77, 0.2), 0 12px 6px 7px rgba(18, 53, 77, 0.04);
    opacity: 1 !important;
    pointer-events: auto;
    z-index: 10000 !important;
}

.pop-hover-wrapper {
  font-family: var(--primary-font-family);

  .pop-hover-footer:empty {
    display: none;
  }

  .pop-hover-header {
    font-size: 13px;
    font-weight: 600;
    padding: 10px;
  }

  .pop-hover-content {
    color: $blue-color-2;
    padding: 10px;
    font-size: 12px;
  }

  .bg-primary {
    color: $blue-color-2;
    background-color: $blue-color-5;
  }

  .bg-warning {
    color: $red-color-1;
    background-color: $red-color-2;
  }
}

</style>
